import React, { Component } from 'react';

import UpdateInfo from './UpdateInfo';
import UserCreate from './userCreate/UserCreate';
import UserManagement from './userManagement/UserManagement';
import SiteManagement from './SiteManagement/SiteManagement';
import Sites from './sites/Sites.js';
import NavBar from './nav/NavBar';
import Logs from './Logs/Logs';
import FullScreenModal from './common/FullScreenModal';

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentView: localStorage.getItem("currentView"),
      isSessionExpired: false,
    };
  }

  componentDidMount = () => {

  }

  changeView = (newView) => {
    fetch(
      '/api/authenticateUser',
      {
        method: "GET",
        credentials: "same-origin",
      },
    )
    .then(res => {
      if (res.ok) {
        this.setState({currentView: newView});
        localStorage.setItem('currentView', newView);
      } else {
        this.setState({ isSessionExpired: true });
      }
    });
  }

  logout = () => {
    localStorage.setItem("currentView", null);
    this.props.logout();
  }

  render() {
    let mainComponent;
    switch(this.state.currentView) {
      case "sites":
        mainComponent = <Sites />;
        break;
      case "updateInfo":
        mainComponent = <UpdateInfo changeView={this.changeView} />
        break;
      case "userCreate":
        mainComponent = <UserCreate changeView={this.changeView} />
        break;
      case "userManagement":
        mainComponent = <UserManagement />
        break;
      case "siteManagement":
        mainComponent = <SiteManagement />
        break;
      case "logs":
        mainComponent = <Logs />
        break;
      default:
        mainComponent = <Sites />;
    }

    return(
      <div className="wrapper">
        <FullScreenModal open={this.state.isSessionExpired} onClose={this.logout}>
          <h4>Session Expired</h4>
          <hr />
          <p>Please log in again.</p>
          <button className={"btn btn-primary"} onClick={this.logout}>Ok</button>
        </FullScreenModal>
        <NavBar
          permissions={this.state.permissions}
          view={this.state.currentView}
          changeView={this.changeView}
          logout={this.logout}
        />

        <div className="row" id = "mainComponentRow">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-1"></div>
              <div className="col-md-10 profile-dashboard">
                <div className="form-horizontal">
                  <div className="bg-white pinside30">

                    {mainComponent}

                  </div>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Dashboard;


// WEBPACK FOOTER //
// ./src/Components/Dashboard.js